import React from 'react';
import type { EndpointSpec, Translate } from '../../../components/apidocs';

/** Payout API — ถอนเงินออกจาก payout wallet */
export const PAYOUT_ENDPOINTS = (t: Translate): EndpointSpec[] => [
  {
    method: 'POST',
    path: '/payout',
    description: t('apiDocs.createPayoutDesc'),
    requests: [{
      heading: 'Request Body',
      variant: 'required',
      rows: [
        { name: 'amount', type: 'number', required: true, description: t('apiDocs.fieldPayoutAmount') },
        { name: 'bank_account_name', type: 'string', required: true, description: t('apiDocs.fieldBankAccountName') },
        { name: 'bank_account_number', type: 'string', required: true, description: t('apiDocs.fieldBankAccountNumber') },
        { name: 'bank_name', type: 'string', required: true, description: t('apiDocs.fieldPayoutBankName') },
        { name: 'reference_id', type: 'string', description: t('apiDocs.fieldPayoutReferenceId') },
        { name: 'note', type: 'string', description: t('common.note') },
        { name: 'callback_url', type: 'string', description: t('apiDocs.fieldPayoutCallbackUrl') },
      ],
    }],
    response: {
      status: 201,
      id: 'create-payout-res',
      code: `{
  "success": true,
  "message": "Payout created successfully, pending admin approval",
  "data": {
    "payout_number": "PAYOUT20251009001",
    "amount": 1000.00,
    "fee_amount": 0,
    "net_amount": 1000.00,
    "status": "pending",
    "bank_account_name": "นาย A",
    "bank_account_number": "1234567890",
    "bank_name": "SCB",
    "reference_id": "YOUR-REF-123",
    "callback_url": "https://your-merchant.com/webhook",
    "created_at": "2025-10-09T12:30:29.000Z"
  }
}`,
    },
  },
  {
    method: 'GET',
    path: '/payout/:payout_number',
    description: t('apiDocs.checkPayoutStatus'),
    response: {
      status: 200,
      id: 'get-payout-res',
      code: `{
  "success": true,
  "data": {
    "payout_number": "PAYOUT20251009001",
    "amount": 1000.00,
    "fee_amount": 0,
    "net_amount": 1000.00,
    "status": "completed",
    "bank_account_name": "นาย A",
    "bank_account_number": "1234567890",
    "bank_name": "SCB",
    "slip_url": "https://...",
    "rejected_reason": null,
    "approved_at": "2025-10-09T12:35:00.000Z",
    "completed_at": "2025-10-09T12:40:00.000Z",
    "created_at": "2025-10-09T12:30:29.000Z",
    "updated_at": "2025-10-09T12:40:00.000Z"
  }
}`,
    },
    statuses: ['pending', 'approved', 'completed', 'rejected'],
    footer: (
      <p className="text-xs text-gray-400 dark:text-slate-500 mt-2">
        * ร้านที่เปิดโหมดจ่ายแบบ P2P จะเห็นเฉพาะ <code className="font-mono">pending</code> → <code className="font-mono">completed</code> (ไม่มีขั้น <code className="font-mono">approved</code>) — ดูรายละเอียดในกล่อง "โหมดจ่ายแบบ P2P" ท้ายหน้านี้
      </p>
    ),
  },
  {
    method: 'GET',
    path: '/payouts',
    description: t('apiDocs.getPayoutsList'),
    requests: [{
      heading: 'Query Parameters',
      variant: 'default',
      rows: [
        { name: 'status', type: 'string', description: t('apiDocs.fieldFilterPayoutStatus') },
        { name: 'limit', type: 'number', default: '50', description: t('apiDocs.fieldLimit') },
        { name: 'offset', type: 'number', default: '0', description: t('apiDocs.fieldOffset') },
      ],
    }],
    response: {
      status: 200,
      id: 'list-payouts-res',
      code: `{
  "success": true,
  "data": [
    {
      "payout_number": "PAYOUT20251009001",
      "amount": 1000.00,
      "fee_amount": 0,
      "net_amount": 1000.00,
      "status": "completed",
      "bank_account_name": "นาย A",
      "bank_account_number": "1234567890",
      "bank_name": "SCB",
      "slip_url": "https://...",
      "approved_at": "2025-10-09T12:35:00.000Z",
      "completed_at": "2025-10-09T12:40:00.000Z",
      "created_at": "2025-10-09T12:30:29.000Z"
    }
  ]
}`,
    },
  },
];
